import { memo, useEffect, useState } from "react";
import { Grid2, Typography, Box } from "@mui/material";
import { useQuery } from "@apollo/client";
import { FETCH_COMPANY } from "@company/graphql/queries/fetchCompany";
import { Query } from "@/app/graphql/codegen";
import BaseSettingsPage from "@settings/base/BaseSettingsPage";
import SettingsCard from "@settings/base/SettingsCard";

const ReadOnlyCompanyProfilePage = memo(() => {
    const { data, loading } = useQuery<Pick<Query, "company">>(FETCH_COMPANY);
    const company = data?.company;
    const [profile, setProfile] = useState("");
    
    // Initialize data from company
    useEffect(() => {
        if (company && company.details?.generatedProfile) {
            setProfile(company.details.generatedProfile);
        }
    }, [company]);
    
    return (
        <BaseSettingsPage 
            title="Firmenprofil"
        >
            <Grid2 container spacing={3}>
                {/* Generated Profile */}
                <Grid2 sx={{ xs: 12, width: '100%' }}>
                    <SettingsCard title="Firmenprofil">
                        {!company?.details?.generatedProfile ? (
                            <Typography variant="body1" color="textSecondary" paragraph>
                                Es wurde noch kein Firmenprofil generiert.
                            </Typography>
                        ) : (
                            <Box 
                                sx={{
                                    width: '100%',
                                    minHeight: '500px',
                                    padding: '16px',
                                    borderRadius: '8px',
                                    border: '1px solid #ccc',
                                    fontFamily: 'inherit',
                                    fontSize: '16px',
                                    lineHeight: '1.5',
                                    whiteSpace: 'pre-wrap'
                                }}
                            >
                                {profile}
                            </Box>
                        )}
                    </SettingsCard>
                </Grid2>
            </Grid2>
        </BaseSettingsPage>
    );
});

export default ReadOnlyCompanyProfilePage; 